import { useTranslation } from 'react-i18next';
import './NewsModal.scss';

export default function NewsModal({ news, onMarkRead }) {
  const { t } = useTranslation('common');

  if (!news || news.length === 0) return null;

  return (
    <div className="news-modal-overlay" onClick={onMarkRead}>
      <div className="news-modal" onClick={(e) => e.stopPropagation()}>
        <div className="news-modal__header">
          <h3 className="news-modal__title">{t('news.title')}</h3>
          <button className="news-modal__close" onClick={onMarkRead}>&times;</button>
        </div>
        <div className="news-modal__body">
          {news.map((item) => (
            <div key={item.id} className="news-modal__item">
              <h4 className="news-modal__item-title">{item.title}</h4>
              <p className="news-modal__item-content">{item.content}</p>
              <span className="news-modal__item-date">{item.created}</span>
            </div>
          ))}
        </div>
        <div className="news-modal__footer">
          <button className="news-modal__btn" onClick={onMarkRead}>
            {t('news.markRead')}
          </button>
        </div>
      </div>
    </div>
  );
}
